const SET_PROJECT = "SET_PROJECT";
const INIT_PROJECT = "INIT_PROJECT";
const SET_PROJECT_LIST_DATA = "SET_PROJECT_LIST_DATA";
const RESET_PROJECT_LIST_DATA = "RESET_PROJECT_LIST_DATA";
const REFRESH_WORK_COSTS = "REFRESH_WORK_COSTS";
const REFRESH_WORK_COSTS_TOTALS = "REFRESH_WORK_COSTS_TOTALS";
const INIT_REFRESH = "INIT_REFRESH";
const SET_OPEN_PLANNING = "SET_OPEN_PLANNING";
const SET_IF_CLOSED = "SET_IF_CLOSED";
const SET_RDA_JOB_RUNNING = "SET_RDA_JOB_RUNNING";
const SET_RUNNING_COST_JOB_RUNNING = "SET_RUNNING_COST_JOB_RUNNING";

export function setProject(payload) {
  return {
    type: SET_PROJECT,
    payload,
  };
}

export function setOpenPlanning(openPlanning) {
  return {
    type: SET_OPEN_PLANNING,
    openPlanning,
  };
}

export function setIfClosed(closed) {
  return {
    type: SET_IF_CLOSED,
    closed,
  };
}

export function setProjectListData(payload) {
  return {
    type: SET_PROJECT_LIST_DATA,
    payload,
  };
}

export function resetProjectListData(key = "") {
  return {
    type: RESET_PROJECT_LIST_DATA,
    payload: {
      key,
    },
  };
}

export function setRefreshWorkCosts(flag) {
  return {
    type: REFRESH_WORK_COSTS,
    flag,
  };
}

export function setRefreshWorkCostsTotals(flag) {
  return {
    type: REFRESH_WORK_COSTS_TOTALS,
    flag,
  };
}

export function initProject() {
  return {
    type: INIT_PROJECT,
    payload: {},
  };
}

export function initRefresh() {
  return {
    type: INIT_REFRESH,
    payload: {},
  };
}

export function setRdaJobRunning(flag) {
  return {
    type: SET_RDA_JOB_RUNNING,
    flag,
  };
}

export function setRunningCostJobRunning(flag) {
  return {
    type: SET_RUNNING_COST_JOB_RUNNING,
    flag,
  };
}

const INIT_STATE = {
  project: {},
  listProjects: {
    expandedTableContent: [],
    expandedRowKeys: [],
  },
  refreshWorkCost: null,
  refreshWorkCostTotals: null,
  openPlanning: null,
  closed: null,
  rdaJobRunning: null,
  runningCostJobRunning: null,
};

export default function ProjectManagementDuck(state = INIT_STATE, action) {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case SET_PROJECT:
      newState.project = action.payload;
      break;
    case INIT_PROJECT:
      newState = INIT_STATE;
      break;
    case SET_PROJECT_LIST_DATA:
      newState.listProjects = action.payload;
      break;
    case RESET_PROJECT_LIST_DATA:
      if (action.payload.key === "") {
        newState.listProjects = {
          expandedTableContent: [],
          expandedRowKeys: [],
        };
      } else {
        newState.listProjects[action.payload.key] = [];
      }
      break;
    case REFRESH_WORK_COSTS:
      newState.refreshWorkCost = action.flag;
      break;
    case REFRESH_WORK_COSTS_TOTALS:
      newState.refreshWorkCostTotals = action.flag;
      break;
    case INIT_REFRESH:
      newState.refreshWorkCost = null;
      newState.refreshWorkCostTotals = null;
      break;
    case SET_OPEN_PLANNING:
      newState.openPlanning = action.openPlanning;
      break;
    case SET_IF_CLOSED:
      newState.closed = action.closed;
      break;
    case SET_RDA_JOB_RUNNING:
      newState.rdaJobRunning = action.flag;
      break;
    case SET_RUNNING_COST_JOB_RUNNING:
      newState.runningCostJobRunning = action.flag;
      break;
    default:
      break;
  }
  return newState;
}
